import React from 'react';
import cn from 'classnames';
import styles from './ModalSubtitle.module.scss';

const ModalSubtitle = ({ subtitle, className }) => {
  return <p className={cn(styles.subtitle, className)}>{subtitle}</p>;
};

export default ModalSubtitle;
